import ConfigParameter, {gettext} from "../ConfigParameter";

export default class Animation extends ConfigParameter {

    constructor() {
        let defaultValueIndex = 1;
        let options = [
            {value: "", label: gettext("Animation disabled")},
            {value: "fade-in", label: gettext("Fade in")},
            {value: "fade-right", label: gettext("Fade right")},
            {value: "fade-left", label: gettext("Fade left")}
        ];

        super('animation', 'object-select', gettext('Animation'), 'mainConfig', options[defaultValueIndex].value, null, options, null, null, gettext('Ignored if section is pinned.'));
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/Animation.js